import commonApiAuthRequest from "../apiAuthRequest"
import { SAP_LOADER_SERVICE_URL } from "./constants"

/*
  Спека
  https://next.stoplight.io/infotech-group/toro-reference-integration/version%2F1.0/toro-sap-loader.oas2.yml?view=%2Freference%2Fget-issue-operations%2Fget-issue-operations
*/

const checksFetch = sapIssueId =>
  commonApiAuthRequest({
    url: `${SAP_LOADER_SERVICE_URL}/get_issue_operations`,
    method: `post`,
    data: {
      where: {
        issueNumber: sapIssueId,
      },
    },
  })

/**
 * makes request to get planned checks by sapIssueId
 *
 * @param {number} sapIssueId
 * @return {Array.<Object>} response - array of planned checks
 */
export const getPlannedChecks = async sapIssueId => {
  if (!sapIssueId) {
    return undefined
  }

  const { data: plannedChecks } = await checksFetch(sapIssueId)

  return plannedChecks
}
